import React, { Suspense } from "react";
import {Route, Switch } from 'react-router-dom';
import "./App.css";

import Auth from './hoc/auth';
import Header from "./components/Header/Header";
import Body from "./components/Body/Body";
import NavBar from "./components/NavBar/NavBar";
import LoginPage from "./components/LoginPage/LoginPage"
import RegisterPage from "./components/RegisterPage/RegisterPage"
import MyResumes from "./components/MyResumes/MyResumes";
import Profile from "./components/Profile/Profile";

function App() {
  return (
      <Suspense fallback = {<div>Loading...</div>}>
        <NavBar/>
        {/* <div style={{ paddingTop: '10px', minHeight: 'calc(10vh)' }}></div> */}
        <Switch>
          <Route exact path="/" component={Auth(Header, null)} />
          <Route exact path="/body" component={Auth(Body, true)}/>
          <Route exact path="/profile" component={Auth(Profile, true)}/>
          {/* <Route exact path="/body" render={(props) => (<Body {...props}/>)}/> */}
          <Route exact path="/myresume" component={Auth(MyResumes, true)}/>
          <Route exact path="/login" component={Auth(LoginPage, false)} />
          <Route exact path="/register" component={Auth(RegisterPage, false)} />
        </Switch>
      </Suspense>
  );
}

export default App;
